import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "fullName",
})
export class FullNamePipe implements PipeTransform {
  transform(user: {
    firstName: string | null;
    lastName: string | null;
    displayName?: string | null;
  }): string {
    const firstName = user.firstName ?? "";
    const lastName = user.lastName ?? "";
    const name = firstName + " " + lastName;
    let fullName = name;
    if (fullName === " ") {
      if (user.displayName) {
        fullName = user.displayName;
      } else {
        fullName = "No Name";
      }
    }
    return fullName;
  }
}
